import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { FileUp, ImageUp, ScanText, List, Globe, Languages, Store, Package, Users, FileText, BookOpen, Layers, Dices, X, Zap, Tag, Coins, Plug } from "lucide-react";
import { AdminLayoutContext } from "@/contexts/AdminLayoutContext";

const adminNavItems = [
  { to: "/admin/pdf-upload", icon: FileUp, label: "PDF UPLOAD" },
  { to: "/admin/image-upload", icon: ImageUp, label: "IMAGE UPLOAD" },
  { to: "/admin/ocr", icon: ScanText, label: "OCR" },
  { to: "/admin/libraries", icon: BookOpen, label: "Könyvtárak" },
  { to: "/admin/categories", icon: List, label: "Kategóriák" },
  { to: "/admin/countries", icon: Globe, label: "Országok" },
  { to: "/admin/languages", icon: Languages, label: "Nyelvek" },
  { to: "/admin/brands", icon: Tag, label: "Márkák" },
  { to: "/admin/shops", icon: Store, label: "Boltok" },
  { to: "/admin/products", icon: Package, label: "Termékek" },
  { to: "/admin/action-presets", icon: Zap, label: "Akciósablonok" },
  { to: "/admin/angebot", icon: Layers, label: "Ajánlatok" },
  { to: "/admin/dicing", icon: Dices, label: "Darabolás" },
  { to: "/admin/deposits", icon: Coins, label: "Betétdíjak" },
  { to: "/admin/ext", icon: Plug, label: "EXT" },
  { to: "/admin/users", icon: Users, label: "User" },
  { to: "/admin/logs", icon: FileText, label: "Log" },
];

const AdminSidebar = () => {
  const { toggleSidebar } = useContext(AdminLayoutContext);

  const handleMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Close sidebar when clicking on nav items or other menu content
    if ((e.target as HTMLElement).closest("a")) {
      toggleSidebar();
    }
  };

  return (
    <aside
      data-admin-sidebar
      className="w-64 bg-card p-4 flex flex-col border-r border-gray-200 dark:border-slate-700"
      onClick={handleMenuClick}
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-primary">Admin Menü</h2>
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleSidebar();
          }}
          className="p-1 hover:bg-gray-200 dark:hover:bg-slate-600 rounded transition-colors"
          aria-label="Menü bezárása"
        >
          <X size={20} />
        </button>
      </div>
      <nav className="flex flex-col space-y-2">
        {adminNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center p-2 rounded-md transition-colors ${isActive
                ? "bg-primary text-primary-foreground"
                : "hover:bg-muted"
              }`
            }
          >
            <item.icon className="mr-3 h-5 w-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;